import { Instance, types } from 'mobx-state-tree'

export enum VehicleHealthStatus {
    HEALTHY = "healthy",
    WARNING = "warning",
    UNHEALTHY = "unhealthy",
}

export const VehicleMaintenanceModel = types.model('VehicleMaintenanceModel')
.props({
    vehicle_id: types.identifierNumber,
    vehicle_aggregated_health_status: types.enumeration('MaintenanceLimitStatus', Object.values(VehicleHealthStatus)),
    vehicle_name: types.maybeNull(types.string),
    is_vehicle_parked: types.boolean,
    is_vehicle_in_service: types.boolean,
    parts_require_inspection: types.number,
    parts_with_upcoming_inspection: types.number,
    parts_expired: types.number,
    parts_with_upcoming_life_limit: types.number,
    unresolved_discrepancy_reports_num: types.number,
})
.views((self) => ({
    get aggregateHealthStatus(): typeof self.vehicle_aggregated_health_status {
        return self.vehicle_aggregated_health_status
    },
    // The health of the vehicle's parts only. The backend also sets WARNING for unresolved discrepancy reports
    // when the parts are healthy, so a WARNING without any part warning came from the reports.
    get partsHealthStatus(): VehicleHealthStatus {
        const hasPartWarnings = self.parts_with_upcoming_inspection > 0 || self.parts_with_upcoming_life_limit > 0
        if (self.vehicle_aggregated_health_status === VehicleHealthStatus.WARNING && !hasPartWarnings) {
            return VehicleHealthStatus.HEALTHY
        }
        return self.vehicle_aggregated_health_status
    },
    get getHealthMessage(): string {
        return  `Vehicle status is ${self.vehicle_aggregated_health_status}:` +
            `${self.parts_expired > 0 ? `\n${self.parts_expired} parts have expired` : ''}` + 
            `${self.parts_with_upcoming_life_limit > 0 ? `\n${self.parts_with_upcoming_life_limit} will soon expire` : ''}` +
            `${self.parts_require_inspection > 0 ? `\n${self.parts_require_inspection} require inspection` : ''}` + 
            `${self.parts_with_upcoming_inspection > 0 ? `\n${self.parts_with_upcoming_inspection} will soon require inspection` : ''}`
    }
}))

export type VehicleMaintenance = Instance<typeof VehicleMaintenanceModel>